import { Checkbox, Grid } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { OrderFormShortRowGridItem } from "../styles";

type Props = {
  value: boolean;
  onChange: (v: boolean) => void;
};

export const FillShiftSelection = ({ value, onChange }: Props) => {
  const { t } = useTranslation("order");
  const [isSelected, setIsSelected] = useState(value);

  return (
    <Grid item container xs={11} justifyContent="flex-start" direction="row">
      <OrderFormShortRowGridItem>
        <Checkbox
          checked={isSelected}
          size="small"
          onChange={() => {
            onChange(!isSelected);
            setIsSelected(!isSelected);
          }}
        />
        {t("fillShift")}
      </OrderFormShortRowGridItem>
    </Grid>
  );
};
